import request from '@/utils/request'

// 业务经理数据中心
export function managerData_index(data) {
  return request({
    url: '/merchant/managerData/index',
    method: 'get',
    params: data
  })
}

// 添加标语与通知
export function managerSlogan_add(data) {
  return request({
    url: '/merchant/managerSlogan/add',
    method: 'post',
    data: data
  })
}

// 获取标语列表
export function managerSlogan_index(data) {
  return request({
    url: '/merchant/managerSlogan/index',
    method: 'get',
    params: data
  })
}
// 农资大市场
export function nongzi_index(data) {
  return request({
    url: '/merchant/nongzi/index',
    method: 'get',
    params: data
  })
}
// 沟通列表
export function contactLog_index(data) {
  return request({
    url: '/merchant/contactLog/index',
    method: 'get',
    params: data
  })
}
// 奖品领取列表
export function userPrize_index(data) {
  return request({
    url: '/merchant/userPrize/index',
    method: 'get',
    params: data
  })
}

// 奖品信息修改字段
export function userPrize_changeField(data) {
  return request({
    url: '/merchant/userPrize/changeField',
    method: 'post',
    data: data
  })
}


// 用户任务列表
export function userTask_index(data) {
  return request({
    url: '/merchant/userTask/index',
    method: 'get',
    params: data
  })
}

// 征集圈列表
export function userPost_index(data) {
  return request({
    url: '/merchant/userPost/index',
    method: 'get',
    params: data
  })
}
// 审核征集圈
export function userPost_changeStatus(data) {
  return request({
    url: '/merchant/userPost/changeStatus',
    method: 'post',
    data: data
  })
}
// 业务经理列表
export function manager_user_index(data) {
  return request({
    url: '/merchant/ManagerUser/index',
    method: 'get',
    params: data
  })
}
// 假期列表 
export function managerDailyReport_index(data) {
  return request({
    url: '/merchant/managerDailyReport/index',
    method: 'get',
    params: data
  })
}
// 添加假期
export function managerDailyReport_add(data) {
  return request({
    url: '/merchant/managerDailyReport/add',
    method: 'post',
    data: data
  })
}

// 线下服务 
export function managerService_index(data) {
  return request({
    url: '/merchant/managerService/index',
    method: 'get',
    params: data
  })
}
// 添加线下服务
export function managerService_add(data) {
  return request({
    url: '/merchant/managerService/add',
    method: 'post',
    data: data
  })
}
// 编辑线下服务
export function managerService_edit(data) {
  return request({
    url: '/merchant/managerService/edit',
    method: 'post',
    data: data
  })
}
// 反馈列表
export function feedback_index(data) {
  return request({
    url: '/merchant/Feedback/index',
    method: 'get',
    params: data
  })
}
// 反馈状态
export function feedback_status(data) {
  return request({
    url: '/merchant/Feedback/changeStatus',
    method: 'post',
    data: data
  })
}
// 反馈导出
export function feedback_export(data) {
  return request({
    url: '/merchant/Export/feedback',
    method: 'post',
    data: data
  })
}


// 意向客户列表
export function intendCustomer_index(data) {
  return request({
    url: '/merchant/intendCustomer/index',
    method: 'get',
    params: data
  })
}
// 处理意向客户
export function intendCustomer_deal(data) {
  return request({
    url: '/merchant/intendCustomer/deal',
    method: 'post',
    data: data
  })
}
// 修改备注
export function intendCustomer_changeRemark(data) {
  return request({
    url: '/merchant/intendCustomer/changeRemark',
    method: 'post',
    data: data
  })
}

// 农资大市场修改备注
export function nongzi_changeRemark(data) {
  return request({
    url: '/merchant/nongzi/changeRemark',
    method: 'post',
    data: data
  })
}

// 问卷
export function Questionnaire_index(data) {
  return request({
    url: '/merchant/Questionnaire/index',
    method: 'get',
    params: data
  })
}

// 微信任务列表
export function wechatTask_index(data) {
  return request({
    url: '/merchant/WechatTask/index',
    method: 'get',
    params: data
  })
}

// 添加微信任务
export function wechatTask_add(data) {
  return request({
    url: '/merchant/WechatTask/add',
    method: 'post',
    data: data
  })
}

// 微信群列表
export function wechatGroups_index(data) {
  return request({
    url: '/merchant/WechatGroups/index',
    method: 'get',
    params: data
  })
}

// 添加/修改微信群
export function wechatGroups_save(data) {
  return request({
    url: '/merchant/WechatGroups/save',
    method: 'post',
    data: data
  })
}
